// Generated by barrles.ps1

export * from "./mailbox.service";
